import * as Sentry from '@sentry/vue'
import { type App } from 'vue'

export const sentryInit = (app: App<Element>) => {
  const envs = ['production']
  if (!envs.includes(import.meta.env.VITE_OUTPUT_ENVIRONMENT)) {
    return
  }

  Sentry.init({
    environment: import.meta.env.VITE_OUTPUT_ENVIRONMENT,
    app,
    dsn: 'https://ec012c469086ccbb20c813724733cdff@o1114978.ingest.sentry.io/4506736262381568'
  })
}

export const sentryCapture = (err: any) => {
  Sentry.captureException(err)
}
